export interface IUserMinimal {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  companyName?: string;
}

export class UserMinimal implements IUserMinimal {
  public firstName?: string;
  public lastName?: string;
  public email?: string;
  public phone?: string;
  public companyName?: string;
}
